import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState, initApplicationConfig } from './ApplicationReducer';

export const selectApplicationState = createFeatureSelector<ApplicationState>('application');

export const initApplicationSelector = createSelector(
  selectApplicationState,
  initApplicationConfig
);
